import type { ExtendedDateTime } from "owa-graph-schema";
import type { OwaDate } from "owa-datetime";
import { owaDate } from "owa-datetime";

export default function owaDateFromGraphDate(date: ExtendedDateTime): OwaDate {
    return owaDate(date.timeZone.name, date.dateTime);
}
